import React from 'react'
import './Hero.css'
import hand_icon from '../Assets/Frontend_Assets/hand_icon.png'
import arrow_icon from '../Assets/Frontend_Assets/arrow.png'
import hero_image from '../Assets/Frontend_Assets/hero_image.png'

const Hero = () => {
    return (
        <div className="hero">
            <div className="hero-left">
                <h2>New Arrivals Only</h2>

                <div className="hero-text">
                    <div className="hero-hand-icon">
                        <p className="new-text">new</p>
                        <img src={hand_icon} alt="hand icon" className="hand-icon" />
                    </div>
                    <p className="collections-text">collections</p>
                    <p className="for-everyone-text">for everyone</p>
                </div>

                <div className="hero-latest-btn">
                    <span>Latest Collection</span>
                    <img src={arrow_icon} alt="arrow icon" />
                </div>
            </div>

            <div className="hero-right">
                <img src={hero_image} alt="hero" className="hero-image" />
            </div>
        </div>
    )
}

export default Hero